import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)
import VeeValidate, {Validator, Configuration} from 'vee-validate';
import VueI18n from 'vue-i18n';
import messagesRU from './locale/ru';
import messagesDE from './locale/de';
import messagesFR from './locale/fr';
import messagesIT from './locale/it';
import pluralization from "./ pluralization"


let messages = {
	de: messagesDE,
	ru: messagesRU,
	fr: messagesFR,
	it: messagesIT,
}
Vue.use(VueI18n)
Vue.use(require('vue-moment'));



const i18n = new VueI18n({
	locale: store.state.locale || 'de',
	messages,
	pluralizationRules: pluralization,
});

// Validator.localize('ru', messagesRu);
Vue.use(VeeValidate, {
	locale: store.state.locale || 'de',
});

// configure({
// 	generateMessage: context => {
// 		return `hello world ${context.field} is invalid`;
// 	},
// });

// axios
import axios from './axios.js';

// headers: {
// 	Authorization: "Bearer " + tokenNew,
// 	lang: localStorage.getItem("lang") || "ru",
// 	'user-interface': store.getters.getUserInterface.id
//   },
//   withCredentials: true,
Vue.prototype.$http = axios;
Vue.prototype.$log = console.log;

function formatDate(str) {
	const date = new Date(str);
	const year = date.getFullYear();
	let month = date.getMonth() + 1;
	month = month >= 10 ? month : "0" + month;
	const day = date.getDate() >= 10 ? date.getDate() : "0" + date.getDate();

	return `${year}-${month}-${day}`;
}
function getFormData(object) {
	if (!object) return null
	const formData = new FormData();
	Object.keys(object).forEach(key => {
		if(Array.isArray(object[key])) {
			for(let item of object[key]) {
				formData.append(`${key}[]`, item);
			}
		} else if(object[key] instanceof Date) {
			formData.append(key, formatDate(object[key]));
		} else {
			formData.append(key, object[key]);
		}
	});

	return formData;
}
function getDeep(key,array,propName="name"){
	if(!array || key === null || key === undefined) return '';
	let findingResult = array.find(obj => obj.id === key);
	return findingResult !== undefined ? findingResult[propName] : '';
}
function getStatusColor(std){
	if(this.$store.state.auth.role === 'client') {
		if (std === 'new'
			|| std === 'client_not_answer'
			|| std === 'processing'
			|| std === 'waiting_payment') return this.$t('status-warn');

		if (std === 'waiting_author'
			|| std === 'waiting_approve'
			|| std === 'patch_mode'
			|| std === 'in_progress') return this.$t('status-warn');

		if (std === 'completed'
			|| std === 'failed_with_payout'
			|| std === 'failed') return this.$t('status-ok');
	}

	if(std === 'new') return '';
	if(std === 'transmitted') return '';
	if(std === 'for_removal') return '';
	if(std === 'client_not_answer') return 'status-warn';
	if(std === 'processing') return 'status-warn';
	if(std === 'waiting_payment') return 'status-warn';
	if(std === 'waiting_author') return 'status-warn';
	if(std === 'waiting_approve') return 'status-warn';
	if(std === 'in_progress') return 'status-warn';
	if(std === 'patch_mode') return 'status-warn';
	if(std === 'completed') return 'status-ok';
	if(std === 'failed_with_payout') return 'status-dang';
	if(std === 'failed') return 'status-dang';
}
function getStatus(std){
	if(this.$store.state.auth.role === 'client') {
		if (std === 'new'
			|| std === 'client_not_answer'
			|| std === 'processing'
			|| std === 'waiting_payment') return this.$t('discuss');

		if (std === 'waiting_author'
			|| std === 'waiting_approve'
			|| std === 'patch_mode'
			|| std === 'in_progress') return this.$t('inProgress');

		if (std === 'completed'
			|| std === 'failed_with_payout'
			|| std === 'failed') return this.$t('completed');
	}

	if(std === 'new') return this.$t('new');
	if(std === 'transmitted') return this.$t('transmitted');
	if(std === 'client_not_answer') return this.$t('clientNotAnswer');
	if(std === 'processing') return this.$t('processing');
	if(std === 'waiting_payment') return this.$t('waitingPayment');

	if(std === 'waiting_author') return this.$t('waitingAuthor');
	if(std === 'waiting_approve') return this.$t('waitingApprove');
	if(std === 'in_progress') return this.$t('inProgress');
	if(std === 'patch_mode') return this.$t('patchMode');

	if(std === 'completed') return this.$t('completed');
	if(std === 'failed_with_payout') return this.$t('failedWithPayout');
	if(std === 'failed') return this.$t('failed');
	if(std === 'trash') return this.$t('trash');
	if(std === 'for_removal') return this.$t('forRemoval');
}

function getStatusPaymentMilestoneColor(std) {
	if(std === true) return 'status-ok';
	if(std === false) return 'status-dang';
}

function getStatusPaymentMilestone(std) {
	if(std === true) return this.$t('checkYesPaymentStage');
	if(std === false) return this.$t('checkNoPaymentStage');
}

Vue.prototype.$formData = getFormData;
Vue.prototype.$getDeep = getDeep;
Vue.prototype.$getStatusColor = getStatusColor;
Vue.prototype.$getStatus = getStatus;
Vue.prototype.$getStatusPaymentMilestoneColor = getStatusPaymentMilestoneColor;
Vue.prototype.$getStatusPaymentMilestone = getStatusPaymentMilestone;
Vue.prototype.$formatDate = formatDate;

// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'

import 'vee-validate'


// Styles: SCSS
import './assets/scss/main.scss'


// Specific import for vue-datetime component
import 'vue-datetime/dist/vue-datetime.css'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer'

Vue.use(VueHammer)


import Vue2Editor from "vue2-editor";

Vue.use(Vue2Editor);

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

axios.interceptors.request.use(
	async config => {
		let token = store.state.auth.token || null;
		if(token){
			config.headers = {
				'Authorization': `Bearer ${token}`,
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		}

		return config;
	},
	error => {
		Promise.reject(error)
	});

axios.interceptors.response.use((response) => {
	return response;
}, function (error) {
	// Do something with response error
	if (error.response.status === 401) {
		console.log('unauthorized, logging out ...');
	}
	let errorBack = error.response.data || error.response;
	return Promise.reject(errorBack);
});


// Feather font icon
require('./assets/css/iconfont.css')

Vue.config.productionTip = false
Vue.config.devtools = true

new Vue({
	router,
	i18n,
	store,
	render: h => h(App)
}).$mount('#app')
